import React from "react";

import type { ArcProps } from "./types";

const Arc = ({ label, value, path, fill, onPointerMove }: ArcProps) => {
  return (
    <g
      key={`arc-${label}`}
      onPointerMove={(event) =>
        onPointerMove(event, { label, value, path, fill })
      }
      onMouseLeave={(event) => onPointerMove(event, undefined)}
    >
      <path
        d={path}
        fill={fill}
      />
    </g>
  );
};

export default Arc;
